<template>
  <div class="d-flex flex-column">
    <subnav :links="subnav" heading="История платежей"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
  export default {
    data: () => ({
      subnav: [
        {
          text: 'Списания',
          to: '/payments/history/charges',
        },
        {
          text: 'Пополнения и возвраты',
          to: '/payments/history/refills',
        },
      ],
    }),
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/payments/history.vue